import { render, staticRenderFns } from "./PaymentApproved.vue?vue&type=template&id=1db530bd&scoped=true"
import script from "./PaymentApproved.vue?vue&type=script&lang=js"
export * from "./PaymentApproved.vue?vue&type=script&lang=js"
import style0 from "./PaymentApproved.vue?vue&type=style&index=0&id=1db530bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db530bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db530bd')) {
      api.createRecord('1db530bd', component.options)
    } else {
      api.reload('1db530bd', component.options)
    }
    module.hot.accept("./PaymentApproved.vue?vue&type=template&id=1db530bd&scoped=true", function () {
      api.rerender('1db530bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/components/tabs/PaymentApproved.vue"
export default component.exports